import { render } from "./CharlaFaqPopup.vue?vue&type=template&id=444ce524&scoped=true"
import script from "./CharlaFaqPopup.vue?vue&type=script&lang=js"
export * from "./CharlaFaqPopup.vue?vue&type=script&lang=js"

import "./CharlaFaqPopup.vue?vue&type=style&index=0&id=444ce524&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444ce524"]])

export default __exports__